<template>
  <div id="meeting_analytics" class="proxima_nova">
    <CustomTabs
      v-model="activeKey"
      :tabs="tabs"
      height="calc(100vh - (170px + var(--banner-height)))"
    >
      <template
        v-for="(tab, index) in tabs"
        :key="index"
        #[`tab_content-${index}`]
      >
        <component :is="tab.component" :visible="activeKey === index" />
      </template>
    </CustomTabs>
  </div>
</template>

<script setup>
import { ref } from "vue";
import store from "@/src/store/index.js";
import CustomTabs from "@/src/components/CustomTabs.vue";
import MeetingsTabAnalytics from "@/src/views/meetings/meeting_agent/MeetingsTabAnalytics.vue";
import RoutingFormsTabAnalytics from "@/src/views/meetings/meeting_agent/RoutingFormsTabAnalytics.vue";

const activeKey = ref(0);
const tabs = ref([
  {
    title: "Meetings",
    component: MeetingsTabAnalytics,
  },
  {
    title: "Routing forms",
    component: RoutingFormsTabAnalytics,
  },
]);

const handleDateRangeUpdate = (value) => {
  try {
    store.dispatch("analytics/updateRange", value);
  } catch (error) {
    console.error(
      "An error occurred while handling date range update: ",
      error,
    );
  }
};
</script>
